import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import dayjs from 'dayjs';
import cN from 'classnames';
import {
    GroupHead,
    GroupAllCalendar,
    GroupAllList,
    GroupAllModeswitcher,
    GroupAllTours,
    GroupDetail,
    GroupTripInfo,
    GroupNotesUpdatetime,
    GroupNotesCanSold,
} from '@components/DetailPage';
import Spinner from '@components/Common/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import {
    setCalendarGroupsMonth,
    setGroupAllCalendar,
    setGroupAllTours,
    setPricesInfo,
    setStationInfo,
    setSki,
    setFlightInfo,
    setCalendarGroupsMode,
    setCalendarGuaranteed,
    setCalendarParmIsEnsureGroup,
    setGroupDetail as setGroupDetailAction,
} from '@Redux/detail/Group/actions';
import { I_Group } from '@Redux/detail/Group/interfaces';
import { RootState } from '@Redux/detail/store';
import { defaultImg43 } from '@utils/defaultImg';

const getMonthStartAndEnd = (day: string) => {
    const start = dayjs(day).startOf('month').format('YYYY-MM-DD');
    const end = dayjs(day).endOf('month').format('YYYY-MM-DD');

    return [start, end];
};

const GroupIntro = () => {
    const { GroupInfo, Schedules, currentTourID, scheduleActive } = useSelector(
        (state: RootState) => state.groupReducer
    );
    const { GroupID, NormGroupID, TourSource, GoDate, ThemeID } = GroupInfo;
    const { isCalendarShowM } = useSelector((state: RootState) => state.switcherReducer);
    const { CalendarGroups } = useSelector((state: RootState) => state.calendarInfoReducer);
    const dispatch = useDispatch();

    // 從後端提供的 div 提供的資料預先載入
    useEffect(() => {
        const { travelinfo, preferairlines } = document.getElementById('detailPagePara')!.dataset!;
        const { GroupInfo: InitialGroupInfo, IsPreview }: I_Group = JSON.parse(travelinfo!);
        const { NormGroupID, TourSource } = InitialGroupInfo;

        const GoDateMonth = dayjs(InitialGroupInfo.GoDate).format('YYYY-MM');
        const [GoDateStart, GoDateEnd] = getMonthStartAndEnd(InitialGroupInfo.GoDate);

        const scheduelsReqBody = {
            NormGroupID,
            TourSource,
        };

        const calendarReqBody = {
            NormGroupID,
            GoDateStart,
            GoDateEnd,
            TourID: currentTourID,
            preferairlines,
            TourSource,
        };

        dispatch(setGroupAllTours(scheduelsReqBody)); // 多行程
        dispatch(setGroupAllCalendar(calendarReqBody)); // 月曆
        dispatch(setCalendarGroupsMonth(GoDateMonth)); // 月曆月份

        // 初始載入時，將 DOM 中的 GroupID 寫入 Redux，以觸發下方的 Effect
        // 預覽模式不需重新抓取 GroupDetail，避免覆蓋掉 DOM 中的資料
        if (!currentTourID && !IsPreview) {
            dispatch(
                setGroupDetailAction({
                    GroupID: InitialGroupInfo.GroupID,
                    TourSource,
                })
            );
        }
    }, [currentTourID, dispatch]);

    // 當 GroupID 改變時 (初始載入或切換行程後)，重新抓取相關資訊
    useEffect(() => {
        if (!GroupID) return;

        const pricesReqBody = {
            GroupID,
            TourSource,
        };

        const stationReqBody = {
            GroupID,
            TourSource,
        };

        const flightInfoReqBody = {
            NormGroupID,
            GroupID,
            GoDate: dayjs(GoDate).format('YYYY-MM-DD'),
            TourSource,
        };

        dispatch(setPricesInfo(pricesReqBody)); // 團費說明
        dispatch(setStationInfo(stationReqBody)); // 集合地點
        dispatch(setFlightInfo(flightInfoReqBody)); // 航班詳情

        if (ThemeID && ThemeID.includes('5')) {
            const skiReqBody = {
                GroupID,
                TourSource,
            };

            dispatch(setSki(skiReqBody)); // 滑雪
        }
    }, [GroupID, NormGroupID, GoDate, TourSource, ThemeID, dispatch]);

    //是否成行
    useEffect(() => {
        // IT 直接給搜尋結果頁的是否「只找成行」參數
        const { isensuregroup } = document.getElementById('detailPagePara')!.dataset!;
        const IsEnsureGroup = isensuregroup!.toLowerCase() === 'true';

        if (IsEnsureGroup) dispatch(setCalendarParmIsEnsureGroup(IsEnsureGroup));
    }, [dispatch]);

    //確認月曆資料是否接無成團
    useEffect(() => {
        const isGuaranteedDisabled = CalendarGroups?.groups.every((item) => {
            return item.Guaranteed == false;
        });
        dispatch(setCalendarGuaranteed(isGuaranteedDisabled));
    }, [CalendarGroups.groups, dispatch]);

    return (
        <div className={`group_wrapper ${isCalendarShowM ? 'sliderOpen' : ''}`}>
            <div className={cN('group_infoImg_m')}>
                {GroupInfo.NormGroupImg ? (
                    <img
                        src={GroupInfo.NormGroupImg}
                        onError={(e: React.SyntheticEvent<HTMLImageElement>) =>
                            ((e.target as HTMLImageElement).src = defaultImg43)
                        }
                        alt={GroupInfo.TourName}
                        width="100%"
                        height="100%"
                    />
                ) : (
                    <img src={defaultImg43} alt={GroupInfo.TourName} />
                )}
            </div>
            <div className={cN('group', 'Container')}>
                <div className={cN('group_container_m')}>
                    <GroupHead />
                    <GroupDetail />
                    <div className="group_all">
                        <GroupAllTours />
                        <div className="group_all_calendar_wrapper">
                            <GroupAllModeswitcher />
                            <GroupAllList />
                            <GroupAllCalendar />
                        </div>
                    </div>
                </div>
                <GroupTripInfo />
                <div className="group_notations">
                    <GroupNotesCanSold />
                    <GroupNotesUpdatetime />
                </div>
            </div>
        </div>
    );
};

export default GroupIntro;
